/**
 * Mock/backend switch for the Setup tabs (brief criterion 22).
 *
 * Runtime flag, read ONCE at module load so one session never mixes
 * sources: `localStorage['dsr_setup:use_mocks'] = '1'` → localStorage
 * mocks exactly as Phase 1; anything else (the default) → webback API.
 * There is no build-time env in this repo (`build.js` has no `define`),
 * hence runtime. Toggle from DevTools and reload.
 */
export const USE_MOCKS = (() => {
	try { return localStorage.getItem('dsr_setup:use_mocks') === '1' } catch { return false }
})()
